import { useCallback, useState } from "react";
import { otherAdjustmentStagingService } from "../services/otherAdjustmentStagingService";

export const useOtherAdjustmentStaging = ({
	setIsUpload,
	isGenerate,
	filterPayTypeId,
	filterPayrollPeriodId,
	filterClassificationId,
}) => {


	const [otherAdjustmentData, setOtherAdjustmentData] = useState([]);
	const [otherLateAdjustmentData, setOtherLateAdjustmentData] = useState([]);
	const [filterDataAdjustment, setFilterDataAdjustment] = useState([]);
	const [filterDataLateAdjustment, setFilterDataLateAdjustment] = useState([]);
	const [loadingAdjustment, setLoadingAdjustment] = useState(false);
	const [loadingLateAdjustment, setLoadingLateAdjustment] = useState(false);


	const fetchAdjustmentData = useCallback(async () => {
		if (!isGenerate) return;

		if (!filterPayTypeId || !filterPayrollPeriodId || !filterClassificationId) return;

		const pathSegments = [
			`paytype/${filterPayTypeId}`,
			`payrollperiod/${filterPayrollPeriodId}`,
			`classification/${filterClassificationId}`
		]
		const processDataParam = pathSegments.join("/");

		try {
			setLoadingAdjustment(true);
			const response = await otherAdjustmentStagingService.getPayrollOtherAdjustments(processDataParam);
			setOtherAdjustmentData(response.data);
			setFilterDataAdjustment(response.data);
			setIsUpload(false);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoadingAdjustment(false);
		}
	}, [
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
		setOtherAdjustmentData,
	]);

	const fetchLateAdjustmentData = useCallback(async () => {
		if (!isGenerate) return;

		if (!filterPayTypeId || !filterPayrollPeriodId || !filterClassificationId) return;

		const pathSegments = [
			`paytype/${filterPayTypeId}`,
			`payrollperiod/${filterPayrollPeriodId}`,
			`classification/${filterClassificationId}`
		]
		const processDataParam = pathSegments.join("/");

		try {
			setLoadingLateAdjustment(true);
			const response = await otherAdjustmentStagingService.getPayrollOtherLateAdjustments(processDataParam);
			setOtherLateAdjustmentData(response.data);
			setFilterDataLateAdjustment(response.data);
			setIsUpload(false);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoadingLateAdjustment(false);
		}
	}, [
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
		setOtherAdjustmentData,
	]);

	return {
		loadingAdjustment, loadingLateAdjustment,
		otherAdjustmentData, setOtherAdjustmentData,
		filterDataAdjustment, setFilterDataAdjustment,
		otherLateAdjustmentData, setOtherLateAdjustmentData,
		filterDataLateAdjustment, setFilterDataLateAdjustment,
		fetchAdjustmentData, fetchLateAdjustmentData
	}
}